module.exports = "<div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 1\"> <categories-input-filter sh-ctrl=$ctrl.shCtrl></categories-input-filter> </div> <div ng-show=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 2\"> <categories-slider-filter company=$ctrl.company sisters=$ctrl.sisters is-procedure=$ctrl.isProcedure sh-ctrl=$ctrl.shCtrl></categories-slider-filter> </div> <div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 3\"> <categories-sliding-filter sh-ctrl=$ctrl.shCtrl></categories-sliding-filter> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/templates/categories-filter-base.view.html
 ** module id = 651
 ** module chunks = 7
 **/